import {
  getApiErrorMessage,
  getErrorMessage,
  getSuccessMessage,
  resolveNoticeMessage,
} from "./apiMessages";

const AGENT_ALERT_EVENT = "way2umrah:agent-alert";
const AGENT_ALERT_STORAGE_KEY = "way2umrah.agent.flash";
export const FINANCE_UPDATED_EVENT = "way2umrah:finance-updated";

export function notifyFinanceUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FINANCE_UPDATED_EVENT));
  }
}

let hydratedPersist = false;
let pendingPersist = null;

function normalizeMessage(message) {
  return String(message || "").trim();
}

function readStoredAlert() {
  if (typeof window === "undefined") {
    return null;
  }

  const raw = window.sessionStorage.getItem(AGENT_ALERT_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    const message = normalizeMessage(parsed?.message);
    if (!message) {
      return null;
    }
    return { type: parsed.type || "info", message };
  } catch (_error) {
    return null;
  }
}

export function persistAgentAlert(type, message) {
  const text = normalizeMessage(message);
  if (!text) {
    return;
  }

  pendingPersist = { type: type || "info", message: text };
  hydratedPersist = true;

  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(AGENT_ALERT_STORAGE_KEY, JSON.stringify(pendingPersist));
  }
}

export function consumePersistedAlert() {
  if (!hydratedPersist) {
    hydratedPersist = true;
    pendingPersist = readStoredAlert();
  }
  return pendingPersist;
}

export function clearPersistedAlert() {
  pendingPersist = null;
  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(AGENT_ALERT_STORAGE_KEY);
  }
}

export function showAgentAlert(type, message, options = {}) {
  const text = normalizeMessage(message);
  if (!text) {
    return;
  }

  const payload = { type: type || "info", message: text, placement: options.placement || "center" };

  if (options.persist) {
    persistAgentAlert(payload.type, payload.message);
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(AGENT_ALERT_EVENT, { detail: payload }));
  }
}

export function showSuccess(message, options) {
  showAgentAlert("success", message, options);
}

export function showError(message, options) {
  showAgentAlert("danger", message, options);
}

export function showWarning(message, options) {
  showAgentAlert("warning", message, options);
}

export function showInfo(message, options) {
  showAgentAlert("info", message, options);
}

export function showSuccessAction(action, options) {
  showSuccess(getSuccessMessage(action) || resolveNoticeMessage(action), options);
}

export function showErrorAction(action, options) {
  showError(getErrorMessage(action), options);
}

export function showApiError(error, fallback, options) {
  showError(getApiErrorMessage(error, fallback), options);
}

export function persistSuccessAction(action) {
  showSuccess(getSuccessMessage(action), { persist: true });
}

export function subscribeToAgentAlerts(listener) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handler = (event) => {
    const detail = event?.detail || {};
    const message = normalizeMessage(detail.message);
    if (!message) {
      return;
    }
    listener({ type: detail.type || "info", message, placement: detail.placement || "toast" });
  };

  window.addEventListener(AGENT_ALERT_EVENT, handler);
  return () => window.removeEventListener(AGENT_ALERT_EVENT, handler);
}
